import React from "react";
import uuid from "react-uuid";

const ProgressBar = ({ archivo }) => {
  const estadoError: string = "Error";

  let GetTipoEstado = function (estado) {
    let estado_;
    switch (estado) {
      case "Cargado":
        estado_ = "bg-success";
        break;
      case "Pendiente":
        estado_ = "bg-warning";
        break;
      case "Error":
        estado_ = "bg-danger";
        break;
      default:
        estado_ = "";
        break;
    }

    return estado_;
  };

  return (
    <React.Fragment>
      <h4 className="small fw-bold text-gray-500">
        {archivo.nombreArchivo}{" "}
        <span className="float-end">
          {(archivo.estado === estadoError ? 0 : archivo.completed) + "%"}
        </span>
      </h4>
      <div id={uuid()} className="progress progress-sm mb-3">
        <div
          className={
            "progress-bar progress-bar-striped progress-bar-animated " +
            GetTipoEstado(archivo.estado)
          }
          aria-valuenow={archivo.completed}
          aria-valuemin="0"
          aria-valuemax="100"
          style={{ width: archivo.completed + "%" }}
        >
          <span className="visually-hidden">{archivo.completed + "%"}</span>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ProgressBar;
